import React, { useContext } from 'react';
import { Tabs } from 'antd';
import classnames from 'classnames';
import AccountTab from './AccountTab';
import MobileTab from './MobileTab';
import LoginContext from '../../context';
import centerstyles from './centerindex.module.less';
import horizonstyles from './horizonindex.module.less';

// declare interface LoginTabsProps {
//   account:, mobile, mode
// }

const LoginTabs = (props: any) => {
  const { mode } = props;
  const styles = mode === 'horizon' ? horizonstyles : centerstyles;
  const { service } = useContext(LoginContext);
  const account = service?.AccountService;
  const mobile = service?.MobileService;
  if (account && mobile) {
    return (
      <Tabs defaultActiveKey="1" className={classnames(styles.tabs, props.className)}>
        <Tabs.TabPane tab="账号" key="1" >
          <AccountTab service={account} styles={styles} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="手机号" key="2">
          <MobileTab service={mobile} styles={styles} />
        </Tabs.TabPane>
      </Tabs>
    );
  }
  if (account) {
    return <AccountTab service={account} styles={styles} />
  }
  if (mobile) {
    return <MobileTab service={mobile} styles={styles} />
  }
  return <></>
};

export default LoginTabs;
